var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselShareReminders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FCF0FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7113_104424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4814 58.2307C51.7657 58.2307 58.4814 51.515 58.4814 43.2307C58.4814 34.9464 51.7657 28.2307 43.4814 28.2307C35.1972 28.2307 28.4814 34.9464 28.4814 43.2307C28.4814 51.515 35.1972 58.2307 43.4814 58.2307Z",
    stroke: "#7479E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0869 53.8369L61.943 61.6922",
    stroke: "#7479E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4814 45.5307C46.349 45.5307 48.6737 43.2061 48.6737 40.3384C48.6737 37.4708 46.349 35.1461 43.4814 35.1461C40.6137 35.1461 38.2891 37.4708 38.2891 40.3384C38.2891 43.2061 40.6137 45.5307 43.4814 45.5307Z",
    stroke: "#7479E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4047 50.9138C49.5299 49.9456 48.4618 49.1718 47.2693 48.6421C46.0768 48.1124 44.7865 47.8387 43.4817 47.8387C42.1768 47.8387 40.8865 48.1124 39.694 48.6421C38.5015 49.1718 37.4334 49.9456 36.5586 50.9138",
    stroke: "#7479E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7113_104424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(24.25 24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselShareReminders);
export default __webpack_public_path__ + "static/media/CarouselShareReminders.5859b48c.svg";
export { ForwardRef as ReactComponent };